
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    modelValue: String
  },

  setup(props, { emit }) {
    function onInputMessage(value: string) {
      emit("update:modelValue", value);
    }

    return { onInputMessage };
  }
});
